export const COMPANY = {
  name: "Auto Socorro Pedrinho",
  title: "Auto Socorro Pedrinho - Guincho 24 Horas em Arujá/SP",
  phone: "(11) 97175-6644",
  phoneHref: "tel:+5511971756644",
  whatsapp: "5511971756644",
  address: "Rod. Pres. Dutra, 199 - Jardim Real, Arujá - SP, 07402-790",
  domain: "https://autosocorropedrinho.site",
};

export const NAV_LINKS = [
  { label: "Serviços", href: "#servicos" },
  { label: "Cidades", href: "#cidades" },
  { label: "Bairros", href: "#bairros" },
  { label: "FAQ", href: "#faq" },
  { label: "Blog", href: "/blog/como-chamar-guincho-em-aruja.html" },
];

export const TRUST_ITEMS = [
  "Atendimento 24 horas",
  "Guincho rápido",
  "Serviço em rodovias",
  "Reboque de carros e motos",
  "Empresa local em Arujá",
  "Atendimento via WhatsApp",
];

export const SERVICES = [
  "Transporte de veículos de outros estados",
  "Reboque de veículos",
  "Socorro mecânico de emergência para veículos",
  "Remoção de veículos estacionados indevidamente",
  "Socorro em caso de pane seca",
  "Socorro mecânico 24h para qualquer tipo de veículo",
  "Guincho para transporte de veículos de carga",
  "Reboque de motos e scooters",
  "Guincho e socorro mecânico para carros de luxo",
  "Remoção de carros abandonados",
  "Guincho para veículos leves",
  "Transporte de veículos para oficinas mecânicas",
  "Transporte de carros de colecionador",
  "Socorro 24h para veículos em rodovias",
  "Guincho para veículos com danos estruturais",
  "Serviço de guincho para mudanças",
  "Guincho para veículos avariados",
  "Guincho 24h",
  "Guincho para veículos em rodovias",
];

export const SERVICE_LINKS = [
  ["Guincho 24 horas", "/servicos/guincho-24-horas.html"],
  ["Reboque de veículos", "/servicos/reboque-de-veiculos.html"],
  ["Socorro mecânico", "/servicos/socorro-mecanico.html"],
  ["Transporte de veículos", "/servicos/transporte-de-veiculos.html"],
  ["Guincho para motos", "/servicos/guincho-para-motos.html"],
  ["Guincho em rodovias", "/servicos/guincho-em-rodovias.html"],
];

export const CITIES = [
  ["Arujá", "/cidades/guincho-em-aruja-sp.html"],
  ["Itaquaquecetuba", "/cidades/guincho-em-itaquaquecetuba-sp.html"],
  ["Santa Isabel", "/cidades/guincho-em-santa-isabel-sp.html"],
  ["Mogi das Cruzes", "/cidades/guincho-em-mogi-das-cruzes-sp.html"],
  ["Região da Rodovia Presidente Dutra", "/servicos/guincho-em-rodovias.html"],
];

export const BAIRROS = [
  "Vila Lima", "Centro", "Chácara São José", "Condomínio Arujazinho I", "Condomínio Arujazinho II", "Condomínio Arujazinho III",
  "Jordanópolis", "Parque Rodrigo Barreto", "Jardim Rincão", "Condomínio Arujá 5", "Condomínio Real Park", "Condomínio Hills III",
  "Arujá Center Ville", "Arujá Centro Residencial", "Arujá Country Club", "Arujá Lagos Residencial", "Arujamérica", "Bairro Ana Rosa",
  "Jardim Planalto", "Jardim Emília", "Jardim Pinheiro", "Jardim Albino Neves", "Jardim das Cerejeiras", "Jardim Fazenda Rincão",
  "Jardim Imperial", "Jardim Nova Arujá", "Jardim Santa Helena", "Jardim Via Nova", "Parque Residencial Vale dos Lagos",
  "Retiro da Ponta da Serra", "Vila Pedroso", "Vila Rincão", "Vila Nova Arujá", "Jardim das Fontes", "Jardim São Bento",
  "Jardim São Camilo", "Jardim São Francisco", "Jardim São Paulo", "Jardim Vitória", "Parque Stella",
];

export const REVIEWS = [
  { name: "Cliente de Arujá", text: "Atendimento rápido, chegou no prazo e resolveu meu problema na Dutra.", date: "há alguns dias" },
  { name: "Motorista atendido em Arujá", text: "Precisei de guincho à noite e fui bem atendido pelo WhatsApp.", date: "há 2 semanas" },
  { name: "Cliente local", text: "Serviço profissional, recomendo para quem precisa de reboque em Arujá.", date: "há 1 mês" },
];

export const FAQS = [
  ["O telefone e endereço da Auto Socorro Pedrinho estão atualizados?", "Sim, estão atualizados."],
  ["Qual é o número de telefone de atendimento ao cliente da Auto Socorro Pedrinho?", "O telefone de atendimento ao cliente da empresa é (11) 97175-6644."],
  ["Onde está localizada a empresa Auto Socorro Pedrinho em Arujá?", "Está localizada na Rod. Pres. Dutra, 199 - Jardim Real, Arujá - SP, 07402-790."],
  ["Como encontrar um guincho perto de mim em Arujá?", "A Auto Socorro Pedrinho está estrategicamente localizada em Arujá, facilitando o atendimento a quem procura por guincho perto de mim com rapidez e confiança."],
  ["Qual cidade a Auto Socorro Pedrinho atende?", "A empresa atende principalmente Arujá/SP e também regiões próximas como Itaquaquecetuba, Santa Isabel e Mogi das Cruzes."],
  ["Qual o horário de funcionamento da Auto Socorro Pedrinho?", "Atendimento 24 horas. Os horários podem variar em feriados e pontos facultativos em Arujá/SP."],
  ["A Auto Socorro Pedrinho atende finais de semana e feriados?", "Sim. O atendimento é 24 horas, inclusive aos finais de semana e feriados."],
  ["A Auto Socorro Pedrinho atende na Rodovia Presidente Dutra?", "Sim. A empresa atende Arujá e região, incluindo chamados próximos à Rodovia Presidente Dutra."],
];